// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gx5x","textarea":"styles_textarea__3A_Sy"};